import { Link } from '@tanstack/react-router';
import { EtainablSpinner } from '@/components/etainabl-spinner';
import { useAdminEditions } from '@/queries/releaseNotes';
import { periodLabel, publishTimeLabel } from '../format';
import { EditionStatusBadge } from './EditionStatusBadge';

export function ReleaseNotesAdminListView() {
  const { data, isLoading } = useAdminEditions();

  return (
    <div className="space-y-4">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold text-etn-text">Release notes</h1>
        <p className="max-w-[70ch] text-etn-cell text-etn-text-label">
          Each Friday’s edition is drafted at 10:00 and goes live at 15:00 once it is approved. Drafts due soonest come first.
        </p>
      </header>

      {isLoading && (
        <div className="flex justify-center py-8">
          <EtainablSpinner size="sm" />
        </div>
      )}

      {!isLoading && !data?.length && (
        <p className="py-8 text-center text-etn-cell text-etn-text-label">No editions yet. The first is drafted on Friday morning.</p>
      )}

      {Boolean(data?.length) && (
        <ul className="divide-y divide-etn-border-row rounded-etn-card border border-etn-border-hairline bg-etn-surface shadow-etn-whisper">
          {data?.map(edition => (
            <li key={edition.key}>
              <Link
                to="/admin/release-notes/$key"
                params={{ key: edition.key }}
                className="flex flex-wrap items-center gap-x-4 gap-y-1 px-5 py-3.5 hover:bg-etn-row-hover"
                data-testid="admin-edition-row"
              >
                <span className="min-w-56 flex-1">
                  <span className="block text-sm font-semibold text-etn-text">{periodLabel(edition)}</span>
                  <span className="block text-etn-micro text-etn-text-soft">
                    {edition.itemCount} note{edition.itemCount === 1 ? '' : 's'} · {edition.excludedCount} left out
                    {edition.review?.editedAt ? ' · edited' : ''}
                  </span>
                </span>
                <span className="text-etn-cell text-etn-text-label">
                  {edition.kind === 'backfill' && edition.status === 'draft' ? 'Live when approved' : publishTimeLabel(edition.publishAt)}
                </span>
                <EditionStatusBadge status={edition.status} publishAt={edition.publishAt} />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
